"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zrxApproveInfinite = exports.zrxApproveAmount = void 0;
const api_1 = require("../../../api");
const erc20_abi_1 = require("../../utils/abi/erc20-abi");
const constants_1 = require("../../utils/constants");
const helpers_1 = require("../../utils/helpers/helpers");
const constants_2 = require("../utils/constants");
const grantAllowanceForAmount = async ({ adapter, web3 }, { quote, wallet }, approvalAmount) => {
    const approvalQuote = {
        ...quote,
        sellAmount: approvalAmount,
        feeData: {
            ...quote.feeData,
            chainSpecific: {
                ...quote.feeData.chainSpecific,
                // 0x approvals are cheaper than trades, but we don't have dynamic quote data for them.
                // Instead, we use a hardcoded gasLimit estimate in place of the estimatedGas in the 0x quote response.
                estimatedGas: constants_1.APPROVAL_GAS_LIMIT,
            },
        },
    };
    return await (0, helpers_1.grantAllowance)({
        quote: approvalQuote,
        wallet,
        adapter,
        erc20Abi: erc20_abi_1.erc20Abi,
        web3,
    });
};
async function zrxApproveAmount(deps, args) {
    var _a;
    try {
        const sellAmount = args.quote.sellAmountBeforeFeesCryptoBaseUnit;
        // If no amount is specified we use the quotes sell amount
        const approvalAmount = (_a = args.amount) !== null && _a !== void 0 ? _a : sellAmount;
        return grantAllowanceForAmount(deps, args, approvalAmount);
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[zrxApproveAmount]', {
            cause: e,
            code: api_1.SwapErrorTypes.APPROVE_AMOUNT_FAILED,
        });
    }
}
exports.zrxApproveAmount = zrxApproveAmount;
async function zrxApproveInfinite(deps, args) {
    try {
        return grantAllowanceForAmount(deps, args, constants_2.MAX_ALLOWANCE);
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[zrxApproveInfinite]', {
            cause: e,
            code: api_1.SwapErrorTypes.APPROVE_INFINITE_FAILED,
        });
    }
}
exports.zrxApproveInfinite = zrxApproveInfinite;
